import React from 'react';
import { 
    TouchableOpacity, 
    View, 
    Text, 
    TextInput,
    StyleSheet, 
    // Modal, 
    ScrollView 
} from "react-native";

import Modal from './base/Modal';

// import Icon from 'react-native-ionicons';
import { Ionicons as Icon } from '@expo/vector-icons';
import { useNavigation } from '@react-navigation/native';
import InputIcon from '../form/InputIcon';
// import { TextInput } from 'react-native-gesture-handler';
import Colors from '../../constants/Colors'
import FontStyles from '../../constants/FontStyle';

const SelectListModal = ({ modalState, hideModal, callback, options, label, placeholder }) => {
    const navigation = useNavigation()
    const [isFocused, setFocus] = React.useState();
    const [inputValue, setInputValue] = React.useState('')
    const [filtered, setFiltered] = React.useState([])

    const handleChange = (val) => {
        val = val.nativeEvent.text
        setInputValue(val)
    }

    const handleBlur = function (e) {
        setFocus(false)
    }

    const goto = (screen) => {
        hideModal()
        navigation.navigate(`${screen}`)
    }

    React.useEffect(() => {

        let val = inputValue !== '' ? inputValue.toLowerCase() : ''
        let list = options.filter(item => {
            let match = false
            Object.keys(item).map(key => {
                if (item[key].toString().toLowerCase().includes(val)) {
                    match = true
                }
            })
            return match
        })
        setFiltered(list)

    }, [inputValue])

    const ListComponent = ({ data }) => {
        return data.map(option => <TouchableOpacity
            key={option._id}
            style={[styles.option]}
            onPress={() => {
                setInputValue('')
                callback(option)
            }}
        >
            <Text style={[styles.optionText]}>{option.name}</Text>
        </TouchableOpacity>)
    }

    return (
        <Modal
            presentationStyle='overFullScreen'
            animationType="slide"
            transparent={true}
            visible={modalState}
            onRequestClose={() => {
                hideModal()
            }}>
            <View style={styles.overlay}>
                <View style={styles.container}>

                    <View style={[styles.card]}>

                        <View style={{
                            flexDirection: 'row',
                            alignItems: 'center'
                        }}>
                            <TouchableOpacity
                                onPress={hideModal}
                                style={{
                                    paddingVertical: 6,
                                    paddingRight: 16,
                                }}>
                                <Icon name="md-arrow-back" size={24} color={Colors.shades._1} />
                            </TouchableOpacity>
                            {/* search bar */}
                            <View
                                style={[
                                    isFocused ? styles.inputGroupFocus : styles.inputGroup,
                                    {
                                        paddingLeft: 0,
                                        borderColor: isFocused ? Colors.tintColor : Colors.borderColor,
                                        flexGrow: 1,
                                    }
                                ]}
                            >
                                <InputIcon name="md-search" size={22} focused={false} />
                                <TextInput
                                    name="query"
                                    value={inputValue}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    onFocus={() => setFocus(true)}
                                    placeholder={placeholder || ''}
                                    style={[
                                        styles.inputControl,
                                        {
                                            textAlignVertical: 'center',
                                            flex: 1
                                        }
                                    ]}
                                />
                                {
                                    inputValue && inputValue !== ''
                                        ? <TouchableOpacity
                                            style={{
                                                height: 38,
                                                width: 38,
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                            onPress={() => setInputValue('')}
                                        >
                                            <Icon name="md-close" size={11.5} />
                                        </TouchableOpacity>
                                        : null
                                }
                            </View>

                        </View>

                        {/* search bar */}
                        <View
                            style={[
                                isFocused ? styles.inputGroupFocus : styles.inputGroup,
                                {
                                    paddingLeft: 0,
                                    display: 'none',
                                    borderColor: isFocused ? '#3B54EC' : '#EAEAEA'
                                }
                            ]}
                        >
                            <InputIcon name="md-search" focused={isFocused} />
                            <TextInput
                                name="query"
                                value={inputValue}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                onFocus={() => setFocus(true)}
                                style={[
                                    styles.inputControl,
                                    {
                                        textAlignVertical: 'center',
                                        flex: 1
                                    }
                                ]}
                            />
                            {
                                inputValue && inputValue !== ''
                                    ? <TouchableOpacity style={{ paddingRight: 10, }} onPress={() => setInputValue('')}>
                                        <InputIcon name="md-close" />
                                    </TouchableOpacity>
                                    : null
                            }
                        </View>

                    </View>

                    <ScrollView contentContainerStyle={[styles.card, {
                        paddingHorizontal: 0,
                        paddingTop: 0,
                        marginTop: 0,
                        flexGrow: 1
                    }]}>
                        {
                            <ListComponent data={filtered && filtered.length ? filtered : options} />
                        }
                    </ScrollView>

                </View>
            </View>
        </Modal>
    )
}

export default SelectListModal

const styles = StyleSheet.create({
    overlay: {
        flex: 1,
        backgroundColor: 'rgba(0,0,0,0.6)',
        alignItems: 'center',
        justifyContent: 'center'
    },
    container: {
        flex: 1,
        width: '100%',
        // paddingHorizontal: 16,
        justifyContent: 'center'
    },
    closeButton: {
        flexDirection: 'row',
        alignSelf: 'flex-end',
        marginBottom: 8,
        marginRight: 16,
    },
    closeButtonText: {
        color: Colors.whiteColor,
        ...FontStyles.size14,
        ...FontStyles.lh16,
        ...FontStyles.bold,
        alignSelf: 'center',
        marginRight: 8,
    },
    card: {
        backgroundColor: '#FFFFFF',
        paddingHorizontal: 20,
        paddingTop: 24,
        paddingBottom: 16,
        borderBottomColor: Colors.borderColor,
        borderBottomWidth: 1,
        borderStyle: 'solid'
        // flex: 1,
    },
    cardBody: {
    },
    inputGroup: {
        flexDirection: 'row',
        height: 40,
        // borderColor: '#EAEAEA',
        borderWidth: 1,
        borderStyle: 'solid',
        borderRadius: 4,
        backgroundColor: Colors.shades._5,
    },
    inputGroupFocus: {
        flexDirection: 'row',
        height: 40,
        // borderColor: '#3B54EC',
        borderWidth: 1,
        borderStyle: 'solid',
        borderRadius: 4,
        backgroundColor: Colors.whiteColor,
    },
    inputControl: {
        flexGrow: 1,
        ...FontStyles.dark,
        ...FontStyles.size15,
        ...FontStyles.lh18,
        ...FontStyles.normal,
        textAlignVertical: 'center',
        paddingVertical: 0,
        alignSelf: 'center',
    },
    option: {
        paddingHorizontal: 16,
        paddingVertical: 14,
        borderBottomColor: Colors.borderColor,
        borderBottomWidth: 1,
        borderStyle: 'solid'
    },
    optionText: {
        ...FontStyles.dark,
        ...FontStyles.size14,
        ...FontStyles.lh20,
        ...FontStyles.normal,
        textAlignVertical: 'center'
    }
})